import React, { useEffect, useRef } from "react";

const BrandCarousel = ({ brands = [] }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    const initializeSwiper = () => {
      if (!window.Swiper || !swiperRef.current) {
        setTimeout(initializeSwiper, 100);
        return;
      }

      if (swiperRef.current.swiper) {
        try {
          swiperRef.current.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }

      // Only enable loop if we have enough slides (at least 2x slidesPerView)
      const totalBrands = brands.length;
      const shouldLoop = totalBrands >= 12; // Need enough slides for loop to work properly
      
      const swiper = new window.Swiper(swiperRef.current, {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: false,
        initialSlide: 0,
        centeredSlides: false,
        autoplay: false,
        freeMode: false,
        allowTouchMove: true, // Enable touch/swipe
        grabCursor: true, // Show grab cursor
        breakpoints: {
          576: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1150: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          // Don't show all brands even on very large screens - keep it scrollable
          // 1400: {
          //   slidesPerView: 8,
          //   spaceBetween: 30,
          // },
        },
        on: {
          init: function () {
            // Ensure we start at the first slide
            this.slideTo(0, 0);
          },
        },
      });

      // Force slide to beginning after initialization
      setTimeout(() => {
        if (swiper && swiper.slideTo) {
          swiper.slideTo(0, 0);
        }
      }, 100);
    };

    initializeSwiper();

    return () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        try {
          swiperRef.current.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }
    };
  }, [brands]);

  return (
    <section className="flat-spacing-25">
      <div className="container">
        <div className="wrap-carousel wrap-brand wrap-brand-v2 autoplay-linear" style={{ width: "100%" }}>
          <div
            dir="ltr"
            ref={swiperRef}
            className="swiper tf-sw-brand border-0"
            style={{ width: "100%", overflow: "hidden" }}
          >
            <div className="swiper-wrapper">
              {brands.map((brand, index) => (
                <div key={index} className="swiper-slide">
                  <div className="brand-item-v2">
                    <img
                      className="lazyload"
                      data-src={brand.image}
                      src={brand.image}
                      alt={brand.name || `brand-${index + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;

